import React, { createElement, useEffect } from "react";
// Extend Window interface to include our guard
declare global {
  interface Window {
    MP_FB_GUARD?: {
      scriptLoaded: boolean;
      pixelInitialized: boolean;
      leadListenersAttached: boolean;
      initialUrl: string;
    };
    fbq?: any;
    _fbq?: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    // Initialize guard if it doesn't exist
    if (!window.MP_FB_GUARD) {
      window.MP_FB_GUARD = {
        scriptLoaded: false,
        pixelInitialized: false,
        leadListenersAttached: false,
        initialUrl: window.location.href
      };
    }
    const guard = window.MP_FB_GUARD;
    // Load Facebook Pixel script only once
    if (!guard.scriptLoaded && !window.fbq) {
      guard.scriptLoaded = true;
      // @ts-ignore
      !function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          b.head.appendChild(t);
        }
      }(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    }
    // Initialize pixel only once
    // Note: fbq('init') automatically fires PageView, so we don't need to track it manually
    if (!guard.pixelInitialized && window.fbq) {
      guard.pixelInitialized = true;
      window.fbq("init", "1936019550624887");
    }
    // Attach Lead event listeners only once
    if (!guard.leadListenersAttached) {
      guard.leadListenersAttached = true;
      const trackLeadOnClick = () => {
        const checkoutButtons = document.querySelectorAll('a[href*="hotmart"], a[href*="pay.hotmart"], a[href*="checkout"]');
        checkoutButtons.forEach(btn => {
          // Check if listener already attached to this specific button
          if (!(btn as any).__mpLeadTracked) {
            (btn as any).__mpLeadTracked = true;
            btn.addEventListener("click", () => {
              if (typeof window.fbq === "function") {
                window.fbq("track", "Lead");
              }
            }, {
              passive: true,
              once: false
            });
          }
        });
      };
      // Run immediately
      trackLeadOnClick();
      // Run once more after delay to catch dynamic buttons
      setTimeout(trackLeadOnClick, 1000);
    }
    // Cleanup function (no-op, guards persist across remounts)
    return () => {
      // Guards intentionally persist to prevent re-initialization
    };
  }, []);
  return <noscript data-id="element-102">
      <img height="1" width="1" style={{
      display: "none"
    }} src="https://www.facebook.com/tr?id=1936019550624887&ev=PageView&noscript=1" alt="" data-id="element-103" />
    </noscript>;
}